import dayjs from 'dayjs';

export const evVehicleOptions = [
  { value: 'EV-001', label: 'B 1234 DMY (EV)' },
  { value: 'EV-002', label: 'B 5678 DMY (EV)' },
  { value: 'EV-003', label: 'B 9012 DMY (DMY)' }
];

const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

export const generateEvData = (vehicleId, fromDateStr, toDateStr) => {
  const isEv1 = vehicleId === 'EV-001';

  const currentStats = {
    avgBatteryLevel: getRandomInt(isEv1 ? 60 : 30, isEv1 ? 100 : 80),
    batteryHealth: getRandomInt(85, 100),
    batteryTemp: getRandomInt(25, 45)
  };

  let start = dayjs('2026-06-01');
  let end = dayjs('2026-06-10');

  if (fromDateStr && dayjs(fromDateStr).isValid()) start = dayjs(fromDateStr);
  if (toDateStr && dayjs(toDateStr).isValid()) end = dayjs(toDateStr);

  if (end.diff(start, 'day') > 30) {
    end = start.add(30, 'day');
  }

  const historyData = [];
  let totalFleetKwh = 0;

  let curr = start;
  while (curr.isBefore(end) || curr.isSame(end, 'day')) {
    const dailyKwh = getRandomInt(100, 300);
    const dailyCost = dailyKwh * getRandomInt(1400, 1600); // estimasi cost misal 1500 per kwh
    totalFleetKwh += dailyKwh;

    historyData.push({
      name: curr.format('DD/MM'),
      fullDate: curr.format('YYYY-MM-DD'),
      kwh: dailyKwh,
      cost: dailyCost
    });

    curr = curr.add(1, 'day');
  }

  const hrs = getRandomInt(1, 4);
  const mins = getRandomInt(0, 59);
  const periodStats = {
    chargingEstimation: `0${hrs}:${mins < 10 ? '0' + mins : mins}:00`,
    totalFleetKwh
  };

  return {
    currentStats,
    periodStats,
    historyData
  };
};
